module.exports = {
    //'baseurl': 'http://192.168.43.77:8083/',    
    'baseurl': './'
}